<script setup>
import { useDisplay } from 'vuetify'

const router = useRouter()
const { isDark, toggle } = useThemeToggle()
const { smAndDown } = useDisplay()

const drawer = ref(false)
const items = [
  { title: 'Home', to: '/', icon: 'mdi-home' },
  { title: 'Services', to: '/services', icon: 'mdi-briefcase' },
  { title: 'Resume', to: '/resume', icon: 'mdi-file-account' },
  { title: 'Gallery', to: '/gallery', icon: 'mdi-image-multiple' },
  { title: 'Contact', to: '/contact', icon: 'mdi-email' },
  { title: 'Blog', to: '/blog', icon: 'mdi-post' },
  { title: 'Store', href: 'https://lolanano.com', icon: 'mdi-store' },
]

function goHome() {
  router.push('/')
}
</script>

<template>
  <v-app-bar flat class="px-2">
    <!-- Mobile hamburger -->
    <v-app-bar-nav-icon v-if="smAndDown" @click="drawer = !drawer" />

    <!-- Logo -->
    <div class="d-flex align-center cursor-pointer" @click="goHome">
      <v-img
        :src="isDark ? '/logo_white.png' : '/logo_black.png'"
        height="36"
        width="36"
        max-width="36"
        class="ml-2"
      />
      <span class="text-subtitle-1 font-weight-bold ml-3 d-none d-sm-inline">andikanu</span>
    </div>

    <v-spacer />

    <!-- Desktop nav links -->
    <div v-if="!smAndDown" class="d-flex align-center ga-1">
      <template v-for="item in items" :key="item.title">
        <v-btn
          v-if="item.to"
          :to="item.to"
          variant="text"
          class="text-capitalize text-body-1"
        >
          {{ item.title }}
        </v-btn>
        <v-btn
          v-else
          :href="item.href"
          target="_blank"
          variant="text"
          class="text-capitalize text-body-1"
        >
          {{ item.title }}
          <v-icon size="14" class="ml-1">
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </template>
    </div>

    <v-spacer />

    <!-- Dark mode toggle -->
    <v-btn icon variant="text" size="small" @click="toggle">
      <v-icon>{{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
    </v-btn>
  </v-app-bar>

  <!-- Mobile drawer -->
  <v-navigation-drawer v-model="drawer" temporary>
    <v-list nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="item.to"
        :href="item.href"
        :target="item.href ? '_blank' : undefined"
        :prepend-icon="item.icon"
        :title="item.title"
        @click="drawer = false"
      />
    </v-list>
    <template #append>
      <div class="pa-4">
        <v-btn block variant="tonal" @click="toggle">
          <v-icon class="mr-2">
            {{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
          </v-icon>
          {{ isDark ? 'Light Mode' : 'Dark Mode' }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
